export default __webpack_public_path__ + "static/media/pro-2.4b10bd7c.jpg";